import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import css from '~/features/dashboard/components/song-details/styles.module.scss';
import { Button, Chip, FormControl, Grid, IconButton, Input, MenuItem, Select, TextField } from '@material-ui/core';
import { axiosInstance } from '~/api/config/axios.config';
import { isArray } from 'class-validator';
import EditIcon from '@material-ui/icons/Edit';
import { EditSynchTab } from '~/features/dashboard/components/song-details/coponents/EditSynchTab';

interface SynchListingTags {
    type: string;
    value: string[];
}

export interface TrackSync {
    songRef: string;
    isrc: string;
    tags: SynchListingTags[];
}

interface SynchTag {
    customField: number;
    id: number;
    listingArea: string;
    listingCode: string;
    listingKey: string;
    listingText: string;
    totalRows: number;
}

interface SynchTabProps {
    close: () => void;
    projectId: any;
    syncData?: TrackSync;
}

const FormSelect: React.FC<{
    title: string;
    projectId: any;
    songRef: any;
    multiselect?: boolean;
    tag: SynchListingTags[];
    setTag: (data: any) => void;
    edit: (data: any, title: string) => void;
}> = ({ title, projectId, songRef, multiselect, tag, setTag, edit }) => {
    let initialSynchTag: SynchTag = {
        customField: 0,
        id: 0,
        listingArea: '',
        listingCode: '',
        listingKey: '',
        listingText: '',
        totalRows: 1,
    };

    const [tagName, setTagName] = React.useState<string[]>([]);
    const [tags, setTags] = React.useState<SynchTag[]>([initialSynchTag]);

    useEffect(() => {
        axiosInstance.get(`/catalogue/projectCreator/userlisting/list?listingkey=SONG${title}&listingarea=PUBLISHING`).then(resp => {
            setTags(resp.data);
        });
        // eslint-disable-next-line
    }, [projectId, songRef, title]);

    const findTags = (data: SynchListingTags[], title: string) => {
        let array: any = data?.filter(p => p.type.toUpperCase() === title.toUpperCase()) || [];
        return array[0]?.value;
    };

    useEffect(() => {
        setTagName(findTags(tag, title) || []);
    }, [tag, title]);

    const handleChange = (event: any) => {
        isArray(event.target.value) ? setTagName(event.target.value as string[]) : setTagName([event.target.value]);
        !isArray(event.target.value) && setTag([event.target.value]);
        if (isArray(event.target.value)) {
            setTag(
                event.target.value.map((item: any) => {
                    return item;
                })
            );
        }
    };

    const handleDelete = (chipToDelete: any) => {
        setTagName(chips => chips.filter(chip => chip !== chipToDelete));
        setTag(tagName.filter(chip => chip !== chipToDelete));
    };

    const editTags = async () => {
        await axiosInstance.get(`/catalogue/projectCreator/userlisting/list?listingkey=${'SONG' + title}&listingarea=PUBLISHING`).then(res => {
            edit(res.data, title);
        });
    };

    return (
        <Grid item xs={6}>
            <div className={css.headerInput}>
                <Typography variant={'subtitle1'}>{title[0].toUpperCase() + title.slice(1)}</Typography>
                <IconButton size="small" title="Edit" onClick={editTags}>
                    <EditIcon fontSize="small" />
                </IconButton>
            </div>
            <CustomSelectChip multiselect={multiselect} handleChange={handleChange} tagName={tagName} tags={tags} handleDelete={handleDelete} />
        </Grid>
    );
};

export const CustomSelectChip: React.FC<{
    multiselect?: boolean;
    tagName: string[];
    handleChange: (event: any) => void;
    tags: SynchTag[];
    handleDelete: (event: any) => void;
}> = ({ multiselect, tagName, handleChange, tags, handleDelete }) => {
    return (
        <>
            <FormControl className={css.textInput}>
                <Select
                    multiple={!!multiselect}
                    displayEmpty
                    value={tagName}
                    onChange={handleChange}
                    input={<Input />}
                    renderValue={(selected: any) =>
                        multiselect ? (
                            (selected as string[]).join(', ')
                        ) : (
                            <div className={css.tags}>
                                {(selected as string[]).map(value => (
                                    <Chip key={`select-item-${value}`} label={value} />
                                ))}
                            </div>
                        )
                    }
                >
                    {tags.map(tag => (
                        <MenuItem key={`tag-item-${tag.listingText}`} value={tag.listingText}>{tag.listingText}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <div className={css.tags}>
                {multiselect &&
                    tagName.length > 0 &&
                    tagName.map(item => {
                        return <Chip key={`chip-item-${item}`} label={item} onDelete={() => handleDelete(item)} />;
                    })}
            </div>
        </>
    );
};

export const SynchTab: React.FC<SynchTabProps> = ({ close, projectId, syncData }) => {
    const initialTags: SynchListingTags[] = [
        {
            type: '',
            value: [],
        },
    ];
    const [tag, setTag] = useState<SynchListingTags[]>(syncData?.tags || initialTags);
    const [description, setDescription] = useState<string>('');
    const [descriptionID, setDescriptionID] = useState<any>();
    const multipleSelect = ['Genre', 'Context', 'Mood', 'Era'];
    const singleSelect = ['Classification', 'Behaviour'];

    useEffect(() => {
        syncData?.songRef &&
            axiosInstance.get('/catalogue/projectCreator/assetTipSheets/list', { params: { assetcode: syncData.songRef } }).then(({ data }) => {
                setDescription(data[0]?.attributeTipValue || '');
                setDescriptionID(data[0]?.iD || '');
            });
        // eslint-disable-next-line
    }, [syncData?.songRef]);

    const [edit, setEdit] = useState([]);
    const [title, setTitle] = useState<string>('');

    const submitBtn = async () => {
        let data: any = {
            ...syncData,
            tags: tag,
        };
        let desc: any = {
            iD: descriptionID,
            assetCode: syncData?.songRef,
            assetTipType: 'Description',
            assetTipExternal: 1,
            attributeTipValue: description,
        };
        await axiosInstance.put('/catalogue/projectCreator/synchsongtag/save', data);
        await axiosInstance.put('/catalogue/projectCreator/assetTipSheets/save', desc);
        close();
    };

    const change = (value: any, type: string) => {
        let tags: any[] = tag || [];
        if (tags && tags.find((item: any) => item.type === type)) {
            tags.find((item: any) => item.type === type).value = value;
        } else {
            tags.push({
                type,
                value,
            });
        }
        setTag(tags);
    };

    return (
        <div>
            <div>
                <div style={{ borderBottom: '1px solid #ccc', padding: '10px 0px 10px 24px', verticalAlign: 'center' }}>
                    <div
                        className={css.closeBtn}
                        onClick={() => {
                            if (edit.length > 0) {
                                setEdit([]);
                            } else {
                                close();
                            }
                        }}
                    >
                        <ArrowBackIcon style={{ verticalAlign: 'center', lineHeight: '10px', cursor: 'pointer' }} />
                        <Typography variant={'h6'} className={css.drawertitle} style={{ lineHeight: '25px', cursor: 'pointer', marginLeft: '0.5rem' }}>
                            {edit.length > 0 ? 'Back' : 'Close'}
                        </Typography>
                    </div>
                </div>
                {edit.length === 0 && (
                    <div className={css.header} style={{ padding: '24px' }}>
                        <Typography variant={'h6'} className={css.drawertitle}>
                            Synch my Song
                        </Typography>
                    </div>
                )}
            </div>
            <div className={css.dspCardbox}>
                {edit.length > 0 ? (
                    <EditSynchTab items={edit} title={title}/>
                ) : (
                    <Grid container spacing={3} className={css.gridContainer}>
                        {multipleSelect.map(item => (
                            <FormSelect
                                edit={(tag, title) => {
                                    setEdit(tag);
                                    setTitle(title);
                                }}
                                projectId={projectId}
                                songRef={syncData?.songRef}
                                title={item}
                                multiselect
                                tag={tag}
                                setTag={value => change(value, item)}
                                key={item}
                            />
                        ))}
                        <Grid item xs={12}>
                            <Typography variant={'subtitle1'}>Description for Synch display</Typography>
                            <TextField
                                defaultValue={description}
                                className={css.textInput}
                                multiline
                                rows={4}
                                variant="outlined"
                                onChange={event => setDescription(event.target.value)}
                            />
                        </Grid>
                        {singleSelect.map(item => (
                            <FormSelect
                                edit={setEdit}
                                projectId={projectId}
                                songRef={syncData?.songRef}
                                title={item}
                                multiselect={false}
                                tag={tag}
                                setTag={value => change(value, item)}
                                key={item}
                            />
                        ))}
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button className={css.button} variant="contained" color="primary" onClick={submitBtn}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </div>
        </div>
    );
};
